(self["webpackChunkgreen_bubble_theme"] = self["webpackChunkgreen_bubble_theme"] || []).push([["/collection-description"],{

/***/ "./src/js/collection-description.js":
/*!******************************************!*\
  !*** ./src/js/collection-description.js ***!
  \******************************************/
/***/ (() => {

(function () {
  // Store original HTML for re-rendering on resize
  var originalHtmlStore = null;
  var lastScreenMode = null;
  function initCollectionDescription(forceReinit) {
    var container = document.getElementById('collection-description-sections');
    if (!container) return;

    // Determine current screen mode
    var currentScreenMode = window.innerWidth >= 768 ? 'desktop' : 'mobile';

    // Check if already processed (has collection-section-block children)
    if (container.querySelector('.collection-section-block') && !forceReinit) {
      return;
    }

    // If forcing reinit and screen mode hasn't changed, skip
    if (forceReinit && lastScreenMode === currentScreenMode) {
      return;
    }
    lastScreenMode = currentScreenMode;

    // Get raw HTML - preserve the original content
    // Use stored original if this is a reinit, otherwise get from container
    var rawHtml;
    if (forceReinit && originalHtmlStore) {
      rawHtml = originalHtmlStore;
    } else {
      rawHtml = container.innerHTML.trim();
      // Store original HTML on first init
      if (!originalHtmlStore && rawHtml) {
        originalHtmlStore = rawHtml;
      }
    }
    if (!rawHtml) {
      console.warn('Collection description: No content found');
      return;
    }

    // Store original HTML in case we need to fall back
    var originalHtml = rawHtml;

    // Clear container
    container.innerHTML = '';

    // Create temporary div to parse HTML
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawHtml;

    // Split content by H2 headings
    var sections = [];
    var currentHeading = null;
    var currentContent = [];
    Array.from(tempDiv.childNodes).forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
        // Save previous section if exists
        if (currentHeading || currentContent.length > 0) {
          sections.push({
            heading: currentHeading,
            content: currentContent
          });
        }
        // Start new section
        currentHeading = node.cloneNode(true);
        currentContent = [];
      } else if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        // Add to current section content
        currentContent.push(node.cloneNode(true));
      }
    });

    // Add last section
    if (currentHeading || currentContent.length > 0) {
      sections.push({
        heading: currentHeading,
        content: currentContent
      });
    }

    // If no sections were created, restore original HTML and return
    if (sections.length === 0) {
      console.warn('Collection description: No sections found, restoring original content');
      container.innerHTML = originalHtml;
      return;
    }

    // Check if desktop (md breakpoint = 768px)
    var isDesktop = window.innerWidth >= 768;

    // Create blocks for each section
    sections.forEach(function (section, index) {
      // Skip empty sections - check if there's any meaningful content
      if (!section.heading && section.content.length === 0) {
        return;
      }

      // Check if all content is empty (only whitespace text nodes)
      if (!section.heading && section.content.length > 0) {
        var hasContent = section.content.some(function (node) {
          if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent.trim().length > 0;
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            return node.textContent.trim().length > 0 || node.children.length > 0;
          }
          return true;
        });
        if (!hasContent) {
          return;
        }
      }
      var sectionBlock = document.createElement('div');
      sectionBlock.classList.add('col-lg-6', 'col-12');
      var innerBlock = document.createElement('div');
      innerBlock.classList.add('collection-section-block');

      // Add heading if exists
      if (section.heading) {
        innerBlock.appendChild(section.heading.cloneNode(true));
      }

      // Create content wrapper
      var contentWrapper = document.createElement('div');
      contentWrapper.classList.add('collection-section-content');

      // Always show full content without truncation on all screen sizes
      section.content.forEach(function (node) {
        contentWrapper.appendChild(node.cloneNode(true));
      });
      innerBlock.appendChild(contentWrapper);
      sectionBlock.appendChild(innerBlock);

      // Only append if there's actual content in the block
      if (contentWrapper.innerHTML.trim() || section.heading) {
        container.appendChild(sectionBlock);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCollectionDescription(false);
    });
  } else {
    // DOM is already ready
    initCollectionDescription(false);
  }

  // Also listen for Shopify section:load event (for theme editor)
  document.addEventListener('shopify:section:load', function () {
    initCollectionDescription(false);
  });

  // Re-render on window resize when crossing mobile/desktop breakpoint
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initCollectionDescription(true);
    }, 150);
  });
})();

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/js/collection-description.js"));
/******/ }
]);